// Peso ausente não significa consumo zero. Mantém os slots do projeto.
export function materiaisDoResultado(data) {
  const materiais = new Map((data.materials || []).map(m => [m.index, { ...m }]));
  for (const placa of data.sliceResult || []) {
    for (const f of placa.filaments || []) {
      if (f.id == null) continue;
      const anterior = materiais.get(f.id) || {};
      materiais.set(f.id, { index: f.id, color: f.color, type: f.type, ...anterior });
    }
  }
  return [...materiais.values()].sort((a, b) => a.index - b.index);
}

export function resumirPlacas(placas) {
  const pesos = {};
  let segundos = 0, pesoTotal = 0;
  let tempoCompleto = true, pesoCompleto = true;
  for (const placa of placas) {
    if (Number.isFinite(placa.predictionSeconds) && placa.predictionSeconds > 0) segundos += placa.predictionSeconds;
    else tempoCompleto = false;
    if (Number.isFinite(placa.weightG)) pesoTotal += placa.weightG;
    else pesoCompleto = false;
    for (const f of placa.filaments || []) {
      if (f.id == null) continue;
      if (!Number.isFinite(f.usedG)) pesos[f.id] = null;
      else if (pesos[f.id] !== null) pesos[f.id] = (pesos[f.id] || 0) + f.usedG;
    }
  }
  // Sem detalhamento de uma placa, o peso acumulado de qualquer slot é parcial.
  if (placas.some(p => !p.filaments?.length)) {
    for (const id of Object.keys(pesos)) pesos[id] = null;
  }
  return { pesos, horas: tempoCompleto && placas.length ? segundos / 3600 : null,
    pesoTotal: pesoCompleto && placas.length ? pesoTotal : null };
}

export function filamentosDetectados(materiais, pesos) {
  return materiais.filter(m => pesos[m.index] !== 0).map(m => ({
    ...m, peso_g: Number.isFinite(pesos[m.index]) ? Math.round(pesos[m.index] * 100) / 100 : null,
  }));
}

// O projeto pode conter placas ainda não fatiadas ao lado de resultados salvos.
export function resultadoSalvoDaImpressora(data, impressora) {
  if (!impressora) return true;
  const modelo = data?.printer?.model || data?.printer?.profile;
  if (!modelo) return false;
  const normalizar = nome => String(nome).toLowerCase().trim()
    .replace(/^bambu(?: lab)?\s+/, "bambu ").replace(/^anycubic\s+/, "")
    .replace(/\s+\d+(?:\.\d+)?\s*(?:mm\s*)?nozzle$/, "")
    .replace(/[^a-z0-9]/g, "");
  return normalizar(modelo) === normalizar(impressora);
}

export function listarPlacasImportacao(data, previews = []) {
  const placas = new Map();
  for (const p of data.sliceResult || []) {
    if (Number.isInteger(p.index) && p.index > 0) placas.set(p.index, { indice: p.index, nome: `Placa ${p.index}` });
  }
  for (const p of previews || []) {
    if (Number.isInteger(p.indice) && p.indice > 0) placas.set(p.indice, { ...placas.get(p.indice), ...p });
  }
  const quantidade = Number.isInteger(data.plates) && data.plates > 0 ? data.plates : 1;
  for (let indice = 1; placas.size < quantidade; indice++) {
    if (!placas.has(indice)) placas.set(indice, { indice, nome: `Placa ${indice}` });
  }
  return [...placas.values()].sort((a, b) => a.indice - b.indice);
}

export function separarPlacasParaFatiar(data, indices, usarResultadosSalvos = true) {
  const resultados = new Map((data.sliceResult || [])
    .filter(p => Number.isFinite(p.predictionSeconds) && p.predictionSeconds > 0)
    .map(p => [p.index, p]));
  const salvas = [], pendentes = [];
  for (const indice of [...new Set(indices)]) {
    if (usarResultadosSalvos && resultados.has(indice)) salvas.push(resultados.get(indice));
    else pendentes.push(indice);
  }
  return { salvas, pendentes };
}
